"use client";

import {
  AnalyticsProvider,
  PageTracker,
} from "@areahub/adapters/src/analytics/analytics.client";
import { GeoLocationProvider } from "@areahub/ui/components/search/contexts";
import { type FC, type PropsWithChildren } from "react";
import { RecoilRoot } from "recoil";

const Providers: FC<PropsWithChildren> = ({ children }) => {
  return (
    <RecoilRoot>
      <AnalyticsProvider writeKey={process.env.SEGMENT_WRITE_KEY as string}>
        <PageTracker />
        <GeoLocationProvider>{children}</GeoLocationProvider>
      </AnalyticsProvider>
    </RecoilRoot>
  );
};

export default Providers;
